import { memoizeWith, identity } from 'ramda';
import { mergeStyles } from '../../../../../internal/utils/mergeStyles';
/** Порядок импорта стилей важен */
import mainStyles from './styles.module.css';
import { getThemeStyles } from './theme';
function getModalFullscreenStyles(theme) {
  const themeStyles = getThemeStyles(theme);
  return mergeStyles(mainStyles, themeStyles);
}
export const getStyles = memoizeWith(identity, getModalFullscreenStyles);